import {Box, Stack, Typography} from "@mui/material";
import {PaymentProviderEnum} from "../types/PaymentProviderEnum.ts";
import {liquidGlassStyle} from "../../app/theme/liquidGlassStyle.ts";

interface IPaymentProviderProps {
    provider: PaymentProviderEnum;
    onClick: () => void;
}

const providerLabels: Record<PaymentProviderEnum, string> = {
    [PaymentProviderEnum.YOOCASSA]: 'YooKassa',
    [PaymentProviderEnum.STARS]: 'Stars',
};

const providerLogos: Record<PaymentProviderEnum, string> = {
    [PaymentProviderEnum.YOOCASSA]: '/logo/yookassa-sign-logo.svg',
    [PaymentProviderEnum.STARS]: '/logo/telegram_stars.svg',
};

export const PaymentProvider = ({provider, onClick}: IPaymentProviderProps) => {
    return (
        <Box
            onClick={onClick}
            sx={{
                ...liquidGlassStyle,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '16px',
                width: '100%',
                cursor: 'pointer',
                borderRadius: '24px',
                textTransform: 'none',
            }}
        >
            <Stack direction="row" alignItems="center" spacing={1}>
                <Box
                    component="img"
                    src={providerLogos[provider]}
                    alt={providerLabels[provider]}
                    sx={{
                        width: '32px',
                        height: '32px',
                        objectFit: 'contain',
                    }}
                />
                <Typography sx={{fontWeight: '500', fontSize: '24px'}}>
                    {providerLabels[provider]}
                </Typography>
            </Stack>
        </Box>
    );
};
